import { useMemo } from "react";
import { ConfirmDialog, wbsTaskDeleteConfirmMessage } from "@/components/app-dialog";
import { useTombstoneSentence } from "@/features/docs/LinkedDocuments";
import { useProjectStore } from "@/store/project-store";

/** WBS 일정 작업 삭제 — 툴바·그리드·컨텍스트 메뉴·명령 팔레트 공통 확인. */
export function WbsDeleteConfirmDialog() {
  const pending = useProjectStore((s) => s.pendingDeleteTaskIds);

  const notice = useTombstoneSentence("scheduleTask", pending ?? []);
  const message = useMemo(() => {
    if (!pending?.length) return null;
    const base = wbsTaskDeleteConfirmMessage(pending.length);
    if (!notice) return base;
    return (
      <>
        {base} {notice}
      </>
    );
  }, [pending, notice]);

  const open = !!pending?.length && message !== null;

  return (
    <ConfirmDialog
      open={open}
      title="작업 삭제"
      message={message}
      onCancel={() => useProjectStore.getState().cancelDeleteTasks()}
      onConfirm={() => {
        const ids = useProjectStore.getState().pendingDeleteTaskIds;
        if (ids?.length) useProjectStore.getState().deleteTasks(ids);
        else useProjectStore.getState().cancelDeleteTasks();
      }}
    />
  );
}
